import { useSelector } from 'react-redux';

import { selectProductDetails, selectProductsList } from '../selectors/products';

export const useProductsList = () => useSelector(selectProductsList);
export const useProductDetails = (id: string) => useSelector(selectProductDetails(id));
